__turbopack_context__.v({
  "badgeWithDistrib": "ryBsSW_badgeWithDistrib",
});
